import { Routes, Route } from "react-router-dom";
import { Dashboard } from "../../tnpsc-component/dashboard";
import { Descriptive } from "../../tnpsc-component/descriptive";
import { ChatScreen } from "../../tnpsc-component/chat-screen";
import { Quiz } from "../../tnpsc-component/quiz";
import {
  ROUTE_CHAT,
  ROUTE_LEARNING_ASSETS,
  ROUTE_AI_ANALYSIS,
  ROUTE_QUIZ,
  ROUTE_DASHBOARD,
  ROUTE_LOGIN,
  ROUTE_AI_GENERATE,
  ROUTE_PROFILE,
  ROUTE_COMPETITIVE_EXAM,
  ROUTE_DESCRIPTIVE,
  ROUTE_MOCK_TEST,
  // ROUTE_PAYMENT_SUCCESS,
} from "../tnpscRoute.js";
import { Login } from "../../tnpsc-component/login";
import { AiGenerator } from "../../tnpsc-component/ai-generator";
import { AiAnalysis } from "../../tnpsc-component/ai-analysis";
import { LearningAssets } from "../../tnpsc-component/learning-assets";
import { CompetitiveExam } from "../../tnpsc-component/competitive-exam";
import { Profile } from "../../tnpsc-component/profile";
import { MockTest } from "../../tnpsc-component/mock-test";
// import { PaymentSuccess } from "../../tnpsc-component/payment-success/index.jsx";

export const TnpscRoutes = () => (
  <Routes>
    <Route path={ROUTE_DASHBOARD} element={<Dashboard />} />
    <Route path={ROUTE_DESCRIPTIVE} element={<Descriptive />} />
    <Route path={ROUTE_CHAT} element={<ChatScreen />} />
    <Route path={ROUTE_QUIZ} element={<Quiz />} />
    <Route path={ROUTE_LOGIN} element={<Login />} />
    <Route path={ROUTE_LEARNING_ASSETS} element={<LearningAssets />} />
    <Route path={ROUTE_AI_GENERATE} element={<AiGenerator />} />
    <Route path={ROUTE_AI_ANALYSIS} element={<AiAnalysis />} />
    <Route path={ROUTE_COMPETITIVE_EXAM} element={<CompetitiveExam />} />
    <Route path={ROUTE_PROFILE} element={<Profile />} />
    <Route path={ROUTE_MOCK_TEST} element={<MockTest />} />
    {/* <Route path={ROUTE_PAYMENT_SUCCESS} element={<PaymentSuccess />} /> */}
  </Routes>
);
